<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>
                         <el-input
                            size="small"
                            style="width:300px;margin-left:30px;"
                            placeholder="请输入姓名 / 账号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="Id"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                            prop="Account"
                            label="账号">
                        </el-table-column>
                        <el-table-column
                            prop="RealName"
                            label="姓名">
                        </el-table-column>
                        <el-table-column
                            prop="Name"
                            label="账号">
                        </el-table-column>
                        <el-table-column
                            prop="GroupName"
                            label="分组">
                        </el-table-column>
                        <el-table-column
                            label="微信">
                            <template slot-scope="scope">
                                  <el-tag
                                  style="margin-left:5px"
                                  size="mini"
                                    v-for="(v,i) in scope.row.Wechats"
                                    :key="i"
                                    effect="dark">
                                    {{ v.NickName+'('+v.WeChat+')' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="update(scope.row)"  icon="el-icon-edit" circle></el-button>
                                <el-button type="danger" size="mini" @click="del(scope.row)"  icon="el-icon-delete" circle></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="添加人员" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="名称：" prop="Name">
                    <el-input placeholder="请输入人员名称" v-model="newModel.Name"></el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="RealName">
                    <el-input placeholder="请输入真实姓名" v-model="newModel.RealName"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="Account">
                    <el-input placeholder="请输入登录账号" v-model="newModel.Account"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="Password">
                    <el-input placeholder="请输入登录密码" v-model="newModel.Password"></el-input>
                </el-form-item>
                <el-form-item label="角色：" prop="Role">
                    <el-radio-group v-model="newModel.Role">
                        <el-radio v-for="item in roleList" :key="item.id" :label="item.id">{{item.Name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分组：">
                    <el-radio-group v-model="newModel.Group">
                        <el-radio :label="0">无</el-radio>
                        <el-radio :label="1">A组</el-radio>
                        <el-radio :label="2">B组</el-radio>
                        <el-radio :label="3">C组</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="微信：">
                    
                    <el-input size="mini" style="width:100px" v-model="wechat.account" placeholder="微信昵称"></el-input>&
                    <el-input size="mini" style="width:100px" v-model="wechat.name" placeholder="微信账号"></el-input>
                    <el-button @click="addWechat" style="margin-left:10px" icon="el-icon-plus" size="mini"></el-button>
                    <div :key="i" v-for="(v,i) in newModel.Wechats">
                        <el-input size="mini" style="width:120px" v-model="v.NickName" placeholder="微信昵称"></el-input>&
                        <el-input size="mini" style="width:120px" v-model="v.WeChat" placeholder="微信账号"></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { manageGet,manageDel,manageSave} from '@/request.js'
import { getRoleSel } from '@/api/role'
export default {
    data(){
        return {
            wechat:{
                name:"",
                account:""
            },
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
            },
            tableData:[],
            newModel:{
                Id:0,
                Account:"",
                Password:"",
                Role:2,
                Name:"",
                RealName:"",
                Group:0,
                Wechats:[],
            },
            rules: {
                Name: [
                    { required: true, message: '请填写人员名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                RealName: [
                    { required: true, message: '请填写真实姓名', trigger: 'blur' },
                    { min: 2, max: 5, message: '长度在 2 到 4 个字符', trigger: 'blur' }
                ],
                Account: [
                    { required: true, message: '请填写登录账号', trigger: 'blur' },
                    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
                ],
                Password: [
                    { required: true, message: '请填登录密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                Role: [
                    { required: true, message: '请选择人员角色', trigger: 'change' }
                ],
            },
            roleList:[]
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
        this.getRole();
    },
    mounted(){
       
    },
    methods: {
        updateWechat(v){
            console.log(v);
        },
        addWechat(){
            if(this.wechat.name==""){
                this.$message({
                    type: 'info',
                    message: '请填写微信昵称'
                });     
                return;
            }
            if(this.wechat.account==""){
                this.$message({
                    type: 'info',
                    message: '请填写微信账号'
                });     
                return;
            }
            this.newModel.Wechats.push({
                WeChat:this.wechat.account,
                NickName:this.wechat.name,
                ManagerId:this.newModel.Id,
                Id:0,
            });
            this.wechat={
                name:"",
                account:""
            };
        },
        update(scope){
            let wechatList=[];
            scope.Wechats.forEach(x=>{
                wechatList.push(x);
            })
            this.newModel={
                Id:scope.Id,
                Account:scope.Account,
                Password:scope.Password,
                Role:scope.Role,
                Name:scope.Name,
                RealName:scope.RealName,
                Group:scope.Group,
                Wechats:wechatList,
            };
            this.dialogFormVisible=true;
        },
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    manageSave({
                        Id:this.newModel.Id,
                        Name:this.newModel.Name,
                        Account: this.newModel.Account,
                        Password:this.newModel.Password,
                        Role:this.newModel.Role,
                        Group:this.newModel.Group,
                        RealName:this.newModel.RealName,
                        WechatJson:this.newModel.Wechats?JSON.stringify(this.newModel.Wechats):"[]",
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.dialogFormVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        add(){
            this.newModel={
                Id:0,
                Account:"",
                Password:"",
                Role:"2",
                Name:"",
                RealName:"",
                Group:0,
                Wechats:[]
            };
            this.dialogFormVisible=true;
            
        },
        del(scope){
            this.$confirm('确认删除该人员吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                manageDel({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.tableData.forEach((item, index, arr)=>{
                            if(item==scope){
                                arr.splice(index, 1);
                            }
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            manageGet(this.queryModel,(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        getRole(){
            getRoleSel(this.queryModel).then(res => {
                this.roleList=res.data
                })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>